import React, { useEffect, useState } from 'react';
import { Col, Row, Alert, Button } from 'react-bootstrap';
import { CheckCircleFill, Icon0Circle } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PaperPlane } from '../components/custom-icons';
import { PublicLayout } from '../components';
import { ForgotPasswordAuthLayout } from '../components/ForgotPasswordAuthLayout';
import image from '../images/img_Hero.jpg';
import { navigateToForgotPassword } from '../redux';
import { ROUTE_PATHS } from '../utils';
import { useSelectTenancyResources } from '../hooks';

export const ForgotPasswordSuccessView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const successMessage = useSelectTenancyResources('forgot-password.success');
  const [preparedSuccessMessage, setPreparedSuccessMessage] = useState<string>('');

  useEffect(() => {
    if (successMessage?.content) {
      const mapObj = {
        '<timeframe>': '24 hours',
        '<system email>': 'caremetx.system.messages@caremetx.com'
      };
      const msg = successMessage?.content?.replace(/<timeframe>|<system email>/gi, (matched: string) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return mapObj[matched];
      });
      setPreparedSuccessMessage(msg);
    }
  }, [successMessage]);

  // Redirect the user if they came to the success page without starting at the forgot password page
  useEffect(() => {
    if (history.action.toString().toLowerCase() === 'pop') {
      dispatch(navigateToForgotPassword());
    }
  }, [history, dispatch]);

  return (
    <PublicLayout fluid className='authlayout_custom_image'>
      <ForgotPasswordAuthLayout>
        <Alert variant='success' className='alert-custom'>
          <p className='mb-0'>
            <h2 className='success-alert-header mb-0'>
              <CheckCircleFill className='success-alert-icon' /> <strong>Success</strong>
            </h2>
          </p>
          <p className='mb-2 ms-4'>
            {' '}
            If an email address you entered exists in our system, you will receive an email with instructions on how to
            reset your password.
          </p>
          <hr className='mt-0 mb-0 ms-4' />
          <p className='mt-2 mb-0 ms-4'>
            {' '}
            If you do not see the email to reset password in your inbox, check your Spam/Junk folder for emails coming
            from caremetx.system.messages@caremetx.com.
          </p>
        </Alert>
        <div className='forgot-password-tittle'>If you need to send the email again, click the button below.</div>
        <div className='mt-4'>
          <Button
            className='d-flex align-items-center px-3 py-2'
            variant='secondary'
            onClick={() => {
              history.push(ROUTE_PATHS.forgotPassword);
            }}>
            Resend Email
            <div>
              <i className='fa-thin fa-paper-plane-top ms-2'></i>
            </div>
          </Button>
        </div>
      </ForgotPasswordAuthLayout>
    </PublicLayout>
  );
};
